import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ISatisFatura_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISatisFatura_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  GetVendorAccounts: any[];
  GetVendorAccounts_dummy: any[];
  GetInvoiceSalesHeader: any[];
  GetInvoiceSalesHeader_dummy: any[];
  GetInvoiceSales: any[];
  GetInvoiceSales_dummy: any[];
  GetInvoiceSalesVendorChar: any[];
  GetInvoiceSalesVendorChar_dummy: any[];
  GetInvoiceSalesVendorCharTotal: any[];
  GetInvoiceSalesVendorCharTotal_dummy: any[];
  GetInvoiceSalesCollectionChar: any[];
  GetInvoiceSalesCollectionChar_dummy: any[];
  GetImage: any[];
  GetImage_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  isComp939690Visible: "visible" | "hidden";
  isComp346579Visible: "visible" | "hidden";
}

export class SatisFatura_ScreenBase extends React.PureComponent<
  ISatisFatura_ScreenProps,
  any
> {
  satisfatura_411475_value_kuikaSelectBoxRef: React.RefObject<any>;
  satisfatura_760966_value_kuikaAutoCompleteRef: React.RefObject<any>;
  satisfatura_537989_value_kuikaSelectBoxRef: React.RefObject<any>;
  satisfatura_303536_value_kuikaSelectBoxRef: React.RefObject<any>;
  satisfatura_209759_value_kuikaSelectBoxRef: React.RefObject<any>;
  satisfatura_888430_value_kuikaTableRef: React.RefObject<any>;
  satisfatura_938086_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "46fce200-952b-48f2-9849-ee9af9f7fb20",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 279091, PropertyName: "label", Value: "Profil" },
        { Id: 349636, PropertyName: "label", Value: "Çıkış Yap" },
        { Id: 632996, PropertyName: "value", Value: "Satış" },
        { Id: 411475, PropertyName: "placeholder", Value: "Zaman Aralığı" },
        { Id: 760966, PropertyName: "placeholder", Value: "Müşteri" },
        { Id: 927759, PropertyName: "value", Value: "Detaylı Filtrele" },
        { Id: 537989, PropertyName: "placeholder", Value: "Koleksiyon" },
        { Id: 303536, PropertyName: "placeholder", Value: "Desen" },
        { Id: 209759, PropertyName: "placeholder", Value: "Ebat" },
        { Id: 621226, PropertyName: "value", Value: "Alınan Sipariş" },
        { Id: 887540, PropertyName: "value", Value: "adet" },
        { Id: 93650, PropertyName: "value", Value: "Sevk Edilen Sipariş" },
        { Id: 275592, PropertyName: "value", Value: "adet" },
        { Id: 485715, PropertyName: "value", Value: "Bekleyen Sipariş" },
        { Id: 358902, PropertyName: "value", Value: "adet" },
        { Id: 259650, PropertyName: "value", Value: "Toplam Satışlar" },
        { Id: 680350, PropertyName: "value", Value: "Satış Dökümü" },
        { Id: 646579, PropertyName: "value", Value: "Satış Toplam Miktar" },
        { Id: 166318, PropertyName: "value", Value: "Satış Toplam Tutar" },
        {
          Id: 550616,
          PropertyName: "value",
          Value: "Koleksiyon Bazında Satışlar",
        },
        { Id: 56337, PropertyName: "value", Value: "Koleksiyon Seç" },
        {
          Id: 888430,
          PropertyName: "nodatafoundmessage",
          Value: "Veri Bulunamadı",
        },
        { Id: 328486, PropertyName: "title", Value: "Title" },
        { Id: 129259, PropertyName: "value", Value: "Fatura No" },
        {
          Id: 77338,
          PropertyName: "value",
          Value: "[datafield:invoicenumber]",
        },
        { Id: 450540, PropertyName: "value", Value: "Müşteri Adı" },
        {
          Id: 936610,
          PropertyName: "value",
          Value: "[datafield:vendordescription]",
        },
        { Id: 375257, PropertyName: "value", Value: "Müşteri Kodu" },
        { Id: 315184, PropertyName: "value", Value: "[datafield:vendorcode]" },
        { Id: 320295, PropertyName: "value", Value: "Miktar" },
        { Id: 390013, PropertyName: "value", Value: "[datafield:qty1]" },
        { Id: 484923, PropertyName: "value", Value: "Tutar" },
        {
          Id: 176436,
          PropertyName: "value",
          Value: "[datafield:loc_netamount]",
        },
        { Id: 277999, PropertyName: "value", Value: "Tarih" },
        { Id: 445407, PropertyName: "value", Value: "[datafield:invoicedate]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.satisfatura_411475_value_kuikaSelectBoxRef = React.createRef();
    this.satisfatura_760966_value_kuikaAutoCompleteRef = React.createRef();
    this.satisfatura_537989_value_kuikaSelectBoxRef = React.createRef();
    this.satisfatura_303536_value_kuikaSelectBoxRef = React.createRef();
    this.satisfatura_209759_value_kuikaSelectBoxRef = React.createRef();
    this.satisfatura_888430_value_kuikaTableRef = React.createRef();
    this.satisfatura_938086_value_kuikaPaginationRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      Logout: false,
      goToSignInActivity: "",
      GetVendorAccounts: [],
      GetInvoiceSalesHeader: [],
      GetInvoiceSales: [],
      GetInvoiceSalesVendorChar: [],
      GetInvoiceSalesVendorCharTotal: [],
      GetInvoiceSalesCollectionChar: [],
      GetImage: [],
      SetValueOf: "",
      dataSource_411475: [
        { key: "1", text: "Bu Gün" },
        { key: "2 ", text: "Son 7 Gün" },
        { key: "3", text: "Son 1 Ay" },
        { key: "4", text: "Son 3 Ay" },
        { key: "5", text: "Son 6 Ay" },
        { key: "6", text: "Son 1 Yıl" },
        { key: "7", text: "Tüm Tarihler" },
      ],
      dataSource_537989: [{ value: "Item 1" }, { value: "Item 2" }],
      dataSource_303536: [{ value: "Item 1" }, { value: "Item 2" }],
      dataSource_209759: [{ value: "Item 1" }, { value: "Item 2" }],
      isComp939690Visible: "hidden",
      isComp346579Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("satisfatura", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.SatisFaturaPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("satisfatura", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("satisfatura", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.SatisFaturaPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  SatisFaturaPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      customerCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      dateFilter_1: ReactSystemFunctions.convertToTypeByName(3, "number"),
      customerCode_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      dateFilter_2: ReactSystemFunctions.convertToTypeByName(3, "number"),
      pageNumber_2: ReactSystemFunctions.convertToTypeByName(1, "number"),
      customerCode_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      dateFilter_3: ReactSystemFunctions.convertToTypeByName(3, "number"),
      customerCode_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      dateFilter_4: ReactSystemFunctions.convertToTypeByName(3, "number"),
      customerCode_5: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      dateFilter_5: ReactSystemFunctions.convertToTypeByName(7, "number"),
      Id_6: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SatisFatura/SatisFaturaPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetVendorAccounts = result?.data.getVendorAccounts;

    formVars.satisfatura_760966_value =
      stateVars.GetVendorAccounts !== undefined
        ? stateVars.GetVendorAccounts?.length > 0
          ? stateVars.GetVendorAccounts[0].currAccCode
          : null
        : this.state.GetVendorAccounts?.length > 0
        ? this.state.GetVendorAccounts[0].currAccCode
        : null;
    formVars.satisfatura_760966_options = stateVars.GetVendorAccounts;
    stateVars.GetInvoiceSalesHeader = result?.data.getInvoiceSalesHeader;
    formVars.satisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty1
        : null
    );
    formVars.satisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty1
        : null
    );
    formVars.satisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty1
        : null
    );
    stateVars.GetInvoiceSales = result?.data.getInvoiceSales;

    stateVars.GetInvoiceSalesVendorChar =
      result?.data.getInvoiceSalesVendorChar;

    stateVars.GetInvoiceSalesVendorCharTotal =
      result?.data.getInvoiceSalesVendorCharTotal;
    formVars.satisfatura_759783_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesVendorCharTotal !== undefined
        ? stateVars.GetInvoiceSalesVendorCharTotal?.length > 0
          ? stateVars.GetInvoiceSalesVendorCharTotal[0].qty1
          : null
        : this.state.GetInvoiceSalesVendorCharTotal?.length > 0
        ? this.state.GetInvoiceSalesVendorCharTotal[0].qty1
        : null
    );
    formVars.satisfatura_551714_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesVendorCharTotal !== undefined
        ? stateVars.GetInvoiceSalesVendorCharTotal?.length > 0
          ? stateVars.GetInvoiceSalesVendorCharTotal[0].doc_NetAmount
          : null
        : this.state.GetInvoiceSalesVendorCharTotal?.length > 0
        ? this.state.GetInvoiceSalesVendorCharTotal[0].doc_NetAmount
        : null
    );
    stateVars.GetInvoiceSalesCollectionChar =
      result?.data.getInvoiceSalesCollectionChar;

    stateVars.GetImage = result?.data.getImage;
    formVars.satisfatura_318098_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SatisFaturaPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SatisFaturaPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.satisfatura_318098_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );

    formVars.satisfatura_760966_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetVendorAccounts !== undefined
        ? stateVars.GetVendorAccounts?.length > 0
          ? stateVars.GetVendorAccounts[0].currAccCode
          : null
        : this.state.GetVendorAccounts?.length > 0
        ? this.state.GetVendorAccounts[0].currAccCode
        : null
    );

    formVars.satisfatura_760966_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetVendorAccounts !== undefined
        ? stateVars.GetVendorAccounts?.length > 0
          ? stateVars.GetVendorAccounts[0].currAccCode
          : null
        : this.state.GetVendorAccounts?.length > 0
        ? this.state.GetVendorAccounts[0].currAccCode
        : null
    );

    stateVars.dataSource_760966 =
      stateVars.GetVendorAccounts ?? this.state.GetVendorAccounts;
    stateVars.dataSource_760966 =
      stateVars.GetVendorAccounts ?? this.state.GetVendorAccounts;
    formVars.satisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty1
        : null
    );

    formVars.satisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty1
        : null
    );

    formVars.satisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty1
        : null
    );

    stateVars.dataSource_533443 =
      stateVars.GetInvoiceSalesVendorChar ??
      this.state.GetInvoiceSalesVendorChar;
    formVars.satisfatura_759783_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesVendorCharTotal !== undefined
        ? stateVars.GetInvoiceSalesVendorCharTotal?.length > 0
          ? stateVars.GetInvoiceSalesVendorCharTotal[0].qty1
          : null
        : this.state.GetInvoiceSalesVendorCharTotal?.length > 0
        ? this.state.GetInvoiceSalesVendorCharTotal[0].qty1
        : null
    );

    formVars.satisfatura_551714_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesVendorCharTotal !== undefined
        ? stateVars.GetInvoiceSalesVendorCharTotal?.length > 0
          ? stateVars.GetInvoiceSalesVendorCharTotal[0].doc_NetAmount
          : null
        : this.state.GetInvoiceSalesVendorCharTotal?.length > 0
        ? this.state.GetInvoiceSalesVendorCharTotal[0].doc_NetAmount
        : null
    );

    stateVars.dataSource_50799 =
      stateVars.GetInvoiceSalesCollectionChar ??
      this.state.GetInvoiceSalesCollectionChar;

    stateVars.dataSource_888430 =
      stateVars.GetInvoiceSales ?? this.state.GetInvoiceSales;
    formVars.satisfatura_938086_total = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoiceSales !== undefined
        ? stateVars.GetInvoiceSales?.length > 0
          ? stateVars.GetInvoiceSales[0].totalCount
          : null
        : this.state.GetInvoiceSales?.length > 0
        ? this.state.GetInvoiceSales[0].totalCount
        : null
    );
    formVars.satisfatura_938086_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoiceSales !== undefined
        ? stateVars.GetInvoiceSales?.length > 0
          ? stateVars.GetInvoiceSales[0].pageCount
          : null
        : this.state.GetInvoiceSales?.length > 0
        ? this.state.GetInvoiceSales[0].pageCount
        : null
    );

    formVars.satisfatura_938086_total = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoiceSales !== undefined
        ? stateVars.GetInvoiceSales?.length > 0
          ? stateVars.GetInvoiceSales[0].totalCount
          : null
        : this.state.GetInvoiceSales?.length > 0
        ? this.state.GetInvoiceSales[0].totalCount
        : null
    );
    formVars.satisfatura_938086_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoiceSales !== undefined
        ? stateVars.GetInvoiceSales?.length > 0
          ? stateVars.GetInvoiceSales[0].pageCount
          : null
        : this.state.GetInvoiceSales?.length > 0
        ? this.state.GetInvoiceSales[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  SatisFaturaComponent_548561_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "SatisFatura",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "181845",
      null,
      "left",
      "true",
      "100vw",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SatisFaturaComponent_279091_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "SatisFatura",
      "ProfileScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SatisFaturaComponent_349636_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SatisFaturaComponent_411475_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      customerCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      customerCode_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      customerCode_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      customerCode_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SatisFatura/SatisFaturaComponent_411475_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoiceSales = result?.data.getInvoiceSales;

    stateVars.GetInvoiceSalesCollectionChar =
      result?.data.getInvoiceSalesCollectionChar;

    stateVars.GetInvoiceSalesHeader = result?.data.getInvoiceSalesHeader;
    formVars.satisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty1
        : null
    );
    formVars.satisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty1
        : null
    );
    formVars.satisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty1
        : null
    );
    stateVars.GetInvoiceSalesVendorChar =
      result?.data.getInvoiceSalesVendorChar;

    stateVars.GetInvoiceSalesVendorCharTotal =
      result?.data.getInvoiceSalesVendorCharTotal;
    formVars.satisfatura_759783_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesVendorCharTotal !== undefined
        ? stateVars.GetInvoiceSalesVendorCharTotal?.length > 0
          ? stateVars.GetInvoiceSalesVendorCharTotal[0].qty1
          : null
        : this.state.GetInvoiceSalesVendorCharTotal?.length > 0
        ? this.state.GetInvoiceSalesVendorCharTotal[0].qty1
        : null
    );
    formVars.satisfatura_551714_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesVendorCharTotal !== undefined
        ? stateVars.GetInvoiceSalesVendorCharTotal?.length > 0
          ? stateVars.GetInvoiceSalesVendorCharTotal[0].doc_NetAmount
          : null
        : this.state.GetInvoiceSalesVendorCharTotal?.length > 0
        ? this.state.GetInvoiceSalesVendorCharTotal[0].doc_NetAmount
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SatisFaturaComponent_411475_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SatisFaturaComponent_411475_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "satisfatura_938086_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );
    formVars.satisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty1
        : null
    );

    formVars.satisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty1
        : null
    );

    formVars.satisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty1
        : null
    );

    stateVars.dataSource_533443 =
      stateVars.GetInvoiceSalesVendorChar ??
      this.state.GetInvoiceSalesVendorChar;
    formVars.satisfatura_759783_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesVendorCharTotal !== undefined
        ? stateVars.GetInvoiceSalesVendorCharTotal?.length > 0
          ? stateVars.GetInvoiceSalesVendorCharTotal[0].qty1
          : null
        : this.state.GetInvoiceSalesVendorCharTotal?.length > 0
        ? this.state.GetInvoiceSalesVendorCharTotal[0].qty1
        : null
    );

    formVars.satisfatura_551714_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesVendorCharTotal !== undefined
        ? stateVars.GetInvoiceSalesVendorCharTotal?.length > 0
          ? stateVars.GetInvoiceSalesVendorCharTotal[0].doc_NetAmount
          : null
        : this.state.GetInvoiceSalesVendorCharTotal?.length > 0
        ? this.state.GetInvoiceSalesVendorCharTotal[0].doc_NetAmount
        : null
    );

    stateVars.dataSource_50799 =
      stateVars.GetInvoiceSalesCollectionChar ??
      this.state.GetInvoiceSalesCollectionChar;

    stateVars.dataSource_888430 =
      stateVars.GetInvoiceSales ?? this.state.GetInvoiceSales;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SatisFaturaComponent_760966_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
      customerCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      customerCode_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      customerCode_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      customerCode_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SatisFatura/SatisFaturaComponent_760966_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoiceSales = result?.data.getInvoiceSales;

    stateVars.GetInvoiceSalesHeader = result?.data.getInvoiceSalesHeader;
    formVars.satisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty1
        : null
    );
    formVars.satisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty1
        : null
    );
    formVars.satisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty1
        : null
    );
    stateVars.GetInvoiceSalesVendorChar =
      result?.data.getInvoiceSalesVendorChar;

    stateVars.GetInvoiceSalesVendorCharTotal =
      result?.data.getInvoiceSalesVendorCharTotal;
    formVars.satisfatura_759783_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesVendorCharTotal !== undefined
        ? stateVars.GetInvoiceSalesVendorCharTotal?.length > 0
          ? stateVars.GetInvoiceSalesVendorCharTotal[0].qty1
          : null
        : this.state.GetInvoiceSalesVendorCharTotal?.length > 0
        ? this.state.GetInvoiceSalesVendorCharTotal[0].qty1
        : null
    );
    formVars.satisfatura_551714_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesVendorCharTotal !== undefined
        ? stateVars.GetInvoiceSalesVendorCharTotal?.length > 0
          ? stateVars.GetInvoiceSalesVendorCharTotal[0].doc_NetAmount
          : null
        : this.state.GetInvoiceSalesVendorCharTotal?.length > 0
        ? this.state.GetInvoiceSalesVendorCharTotal[0].doc_NetAmount
        : null
    );
    stateVars.GetInvoiceSalesCollectionChar =
      result?.data.getInvoiceSalesCollectionChar;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SatisFaturaComponent_760966_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SatisFaturaComponent_760966_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "satisfatura_938086_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );
    formVars.satisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty1
        : null
    );

    formVars.satisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty1
        : null
    );

    formVars.satisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty1
        : null
    );

    stateVars.dataSource_533443 =
      stateVars.GetInvoiceSalesVendorChar ??
      this.state.GetInvoiceSalesVendorChar;
    formVars.satisfatura_759783_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesVendorCharTotal !== undefined
        ? stateVars.GetInvoiceSalesVendorCharTotal?.length > 0
          ? stateVars.GetInvoiceSalesVendorCharTotal[0].qty1
          : null
        : this.state.GetInvoiceSalesVendorCharTotal?.length > 0
        ? this.state.GetInvoiceSalesVendorCharTotal[0].qty1
        : null
    );

    formVars.satisfatura_551714_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesVendorCharTotal !== undefined
        ? stateVars.GetInvoiceSalesVendorCharTotal?.length > 0
          ? stateVars.GetInvoiceSalesVendorCharTotal[0].doc_NetAmount
          : null
        : this.state.GetInvoiceSalesVendorCharTotal?.length > 0
        ? this.state.GetInvoiceSalesVendorCharTotal[0].doc_NetAmount
        : null
    );

    stateVars.dataSource_50799 =
      stateVars.GetInvoiceSalesCollectionChar ??
      this.state.GetInvoiceSalesCollectionChar;

    stateVars.dataSource_888430 =
      stateVars.GetInvoiceSales ?? this.state.GetInvoiceSales;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SatisFaturaComponent_451228_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "KoleksiyonSecSatis",
      "CustomerName",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccDescription"
          )
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "KoleksiyonSecSatis",
      "CustomerCode",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "KoleksiyonSecSatis",
      "dateFilter",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "SatisFatura",
      "KoleksiyonSecSatis",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SatisFaturaComponent_938086_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_938086_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SatisFatura/SatisFaturaComponent_938086_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoiceSales = result?.data.getInvoiceSales;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SatisFaturaComponent_938086_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SatisFaturaComponent_938086_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_888430 =
      stateVars.GetInvoiceSales ?? this.state.GetInvoiceSales;
    formVars.satisfatura_938086_total = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoiceSales !== undefined
        ? stateVars.GetInvoiceSales?.length > 0
          ? stateVars.GetInvoiceSales[0].totalCount
          : null
        : this.state.GetInvoiceSales?.length > 0
        ? this.state.GetInvoiceSales[0].totalCount
        : null
    );
    formVars.satisfatura_938086_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoiceSales !== undefined
        ? stateVars.GetInvoiceSales?.length > 0
          ? stateVars.GetInvoiceSales[0].pageCount
          : null
        : this.state.GetInvoiceSales?.length > 0
        ? this.state.GetInvoiceSales[0].pageCount
        : null
    );

    formVars.satisfatura_938086_total = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoiceSales !== undefined
        ? stateVars.GetInvoiceSales?.length > 0
          ? stateVars.GetInvoiceSales[0].totalCount
          : null
        : this.state.GetInvoiceSales?.length > 0
        ? this.state.GetInvoiceSales[0].totalCount
        : null
    );
    formVars.satisfatura_938086_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoiceSales !== undefined
        ? stateVars.GetInvoiceSales?.length > 0
          ? stateVars.GetInvoiceSales[0].pageCount
          : null
        : this.state.GetInvoiceSales?.length > 0
        ? this.state.GetInvoiceSales[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [181845, ,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.SatisFaturaPageInit();
    }
  }
}
